import React from 'react';
import './VenueSingle.css';

import { Lightbox, PageSidebar, PageTitle } from '../../../components';

import { FaCheckCircle, FaWarehouse } from 'react-icons/fa';

import { useLocation } from 'react-router-dom';



const VenueSingle = () => { 

  // Get the venue data from the router state
  const location = useLocation();  
  const venue = location.state; 

  return (
    <>
      {/* Page Title */}
      <PageTitle title={venue.title} page={"Venue Single"} />

      <section className='venue-single page-single'>

        <div className='venue-info page-info'>

          {/* Venue Image */}
          <div className='image'>
            <img src={venue.image} alt={venue.title} />
          </div>

          <div className='content'>

            {/* Venue Name */}
            <h3 className='main-heading'>{venue.title}</h3>

            {/* Venue Description */}
            {venue.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {/* Venue Image gallery */}
            <Lightbox images={venue.gallery} />

            {/* Venue Spaces Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Venue Spaces:</h3>
              <p>{venue.title} offers a variety of venue spaces designed to suit different event styles and group sizes, including:</p>

              {/* List of Venue Spaces */}
              <ul>
                {venue.venueSpaces.map((space, index) => (
                  <li key={index}>
                    <div className='icon'> <FaWarehouse /> </div>
                    {space}
                  </li>
                ))}
              </ul>

            </div>

            {/* Venue Amenities Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Venue Amenities:</h3>
              <p>{venue.title} offers a range of premium amenities designed to enhance your event experience, including:</p>

              {/* List of Venue Amenities */}
              <ul>
                {venue.amenities.map((amenity, index) => (
                  <li key={index}>
                    <div className='icon'> <FaCheckCircle /> </div>
                    {amenity}
                  </li>
                ))}
              </ul>

            </div>

            {/* Venue Map */}
            <div className="venue-map sub-section">
              <h3 className="sub-heading">Venue Location:</h3>
              <iframe
                src={venue.venueMap}
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="Venue Location Map"
              ></iframe> 
            </div>

          </div> 
        
        </div> 

        {/* Sidebar with Venue Details */}
        <PageSidebar
          heading={'Venue'}
          details={venue.details}
          button={{ link: 'Get-Quote', title: 'Book Now' }}
        />

      </section>

    </> 
  );
}

export default VenueSingle;